import {
  makeGetRequest,
  makePostRequest,
  makeDeleteRequest,
} from 'lib/axios';
import { PaginateResult, PaginationRequestPayload } from 'types';
import { IBusinessCard } from '../types/businessInterface';

const getBusinessCardPagination = async (
  payload: PaginationRequestPayload,
): Promise<{ apps: PaginateResult<IBusinessCard> }> => {
  const { page, limit, sortColumn, sortType, search } = payload;

  const url = `/labs/business/pagination?page=${page}&limit=${limit}&sortColumn=${sortColumn}&sortType=${sortType}&search=${search}`;

  const response = await makeGetRequest(url);
  return response.data.payload;
};

const addBusinessCard = async (
  payload: IBusinessCard,
): Promise<IBusinessCard> => {
  const url = `/labs/business`;

  const {
    name,
    organization,
    title,
    email,
    phoneNumber,
    website,
    notes,
    date,
  } = payload;

  const dtoPayload = {
    name,
    organization,
    title,
    email,
    phoneNumber,
    website,
    notes,
    // Backend expects a date string (IsDateString); normalize Date or string to ISO.
    date: date ? new Date(date as any).toISOString() : undefined,
  };

  const response = await makePostRequest(url, dtoPayload);

  return response.data.payload;
};

const deleteBusinessCard = async (id: string): Promise<void> => {
  const url = `/labs/business/${id}`;

  const response = await makeDeleteRequest(url);

  return response.data.payload;
};

export { getBusinessCardPagination, addBusinessCard, deleteBusinessCard };
